import { makeStyles } from "@material-ui/core"

export const AuditListStyles = makeStyles((theme) => ({
    table: {
        flex: 1
    },
}));